﻿import { createContext } from 'react';
import type { AuthContextType } from './auth-context.types.ts';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
